// src/components/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomePage.css';

const Footer: React.FC = () => {
  return (
    <footer className="holy-footer">
      <div className="footer-wave"></div>
      
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-icon">🐾</span>
              <span className="logo-text">HolyDogs</span>
            </div>
            <p className="brand-tagline">Bringing joy to families through perfect puppy matches since 2018</p>
            
            <div className="social-icons">
              <a href="#" className="social-icon">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-tiktok"></i>
              </a>
              <a href="#" className="social-icon">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          <div className="footer-links-group">
            <div className="footer-links">
              <h4 className="links-header">
                <i className="fas fa-paw"></i> Explore
              </h4>
              <ul>
                <li><Link to="/"><i className="fas fa-home"></i> Home</Link></li>
                <li><Link to="/pages/pets"><i className="fas fa-dog"></i> Available Puppies</Link></li>
                <li><Link to="/pages/how-it-works"><i className="fas fa-clipboard-list"></i> How It Works</Link></li>
                <li><Link to="/pages/breeders"><i className="fas fa-user-friends"></i> Our Breeders</Link></li>
                <li><Link to="/pages/resources"><i className="fas fa-book"></i> Resources</Link></li>
              </ul>
            </div>

            <div className="footer-links">
              <h4 className="links-header">
                <i className="fas fa-paw"></i> Support
              </h4>
              <ul>
                <li><Link to="/pages/faq"><i className="fas fa-question-circle"></i> FAQ</Link></li>
                <li><Link to="/pages/contact"><i className="fas fa-envelope"></i> Contact Us</Link></li>
                <li><Link to="/pages/health"><i className="fas fa-heart"></i> Health Guarantee</Link></li>
                <li><Link to="/pages/shipping"><i className="fas fa-truck"></i> Shipping Policy</Link></li>
                <li><Link to="/pages/privacy"><i className="fas fa-shield-alt"></i> Privacy Policy</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer-contact">
            <h4 className="links-header">
              <i className="fas fa-paw"></i> Contact Us
            </h4>
            <ul className="contact-info">
              <li>
                <i className="fas fa-phone-alt contact-icon"></i>
                <div>
                  <span className="contact-label">Phone</span>
                  <span>(800) 738-7297</span>
                </div>
              </li>
              <li>
                <i className="fas fa-envelope contact-icon"></i>
                <div>
                  <span className="contact-label">Email</span>
                  <span>hello@holydogs.com</span>
                </div>
              </li>
              <li>
                <i className="fas fa-map-marker-alt contact-icon"></i>
                <div>
                  <span className="contact-label">Location</span>
                  <span>123 Puppy Lane, San Francisco, CA</span>
                </div>
              </li>
            </ul>
            
           
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} HolyDogs. All rights reserved.</p>
          <div className="payment-methods">
            <i className="fab fa-cc-visa"></i>
            <i className="fab fa-cc-mastercard"></i>
            <i className="fab fa-cc-amex"></i>
            <i className="fab fa-cc-paypal"></i>
            <i className="fab fa-cc-apple-pay"></i>
          </div>
        </div>
      </div>
      
      <div className="footer-dogs">
        <div className="dog-paw"></div>
        <div className="dog-paw"></div>
        <div className="dog-paw"></div>
      </div>
    </footer>
  );
};

export default Footer;